import React from "react";

import ItineraryPreviewContent from "../components/trips/preview-itinerary-content";

const ItineraryPreview = () => {
  return <ItineraryPreviewContent />;
};

export default ItineraryPreview;
